import { juzLabel } from '@/lib/utils/format';

type JuzPillProps = {
  juz: number | null | undefined;
};

export function JuzPill({ juz }: JuzPillProps) {
  const label = juzLabel(juz);
  if (!label) return null;
  return <span className="pill">{label}</span>;
}
